import React, {ChangeEventHandler, forwardRef, InputHTMLAttributes} from 'react'

import cn from 'classnames/bind'

import s from './Radio.module.scss'
import {IFieldBase} from '../Input/Input'

const cx = cn.bind(s)

export interface IRadioProps
	extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value'>,
		IFieldBase {
	className?: string
	classNameLabel?: string
	classNameWrapper?: string
	value?: string | number
	onChange?: ChangeEventHandler<HTMLInputElement> | undefined
	showError?: boolean
	showRequired?: boolean
	disabled?: boolean
}

const Radio = forwardRef<HTMLInputElement, IRadioProps>(
	(
		{
			className,
			classNameLabel,
			classNameWrapper,
			label,
			error,
			showError = true,
			showRequired = true,
			disabled,
			value,
			...props
		},
		ref,
	) => {
		return (
			<div className={cx('wrapper', {isError: !!error, disabled}, classNameWrapper)}>
				<label className={cx('label', classNameLabel)}>
					<input
						className={cx('input', className)}
						type="radio"
						value={value}
						{...props}
						ref={ref}
					/>
					<span className={cx('text', 'global-label-text')}>
						{label} {props.required && showRequired && <span className={cx('star')}>*</span>}{' '}
					</span>
				</label>

				{!!error && showError && <p className={s.error}>{error}</p>}
			</div>
		)
	},
)

Radio.displayName = 'Radio'

export default Radio
